import {Component} from 'react'
import PropTypes from 'prop-types'
import {Input} from "reactstrap"
import CardRow from "../../../Styled/Card/CardRow.jsx"
import CardCol from "../../../Styled/Card/CardCol.jsx"

class FilterPrices extends Component {
  static propTypes = {
    priceMin: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    priceMax: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    className: PropTypes.string,
    onChange: PropTypes.func.isRequired,
  }

  static defaultProps = {
    priceMin: null,
    priceMax: null,
    className: '',
  }

  constructor(props) {
    super(props)

    this.state = {
      priceMin: props.priceMin ?? null,
      priceMax: props.priceMax ?? null,
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.priceMin !== this.props.priceMin || prevProps.priceMax !== this.props.priceMax) {
      this.setState({
        priceMin: this.props.priceMin ?? null,
        priceMax: this.props.priceMax ?? null,
      })
    }
  }

  onPriceMinChange = (event) => {
    const value = event.currentTarget.value
    this.setState({ priceMin: value })
    this.props.onChange({priceMin: value})
  }
  onPriceMaxChange = (event) => {
    const value = event.currentTarget.value
    this.setState({ priceMax: value })
    this.props.onChange({priceMax: value})
  }

  render() {
    return (
      <CardRow gap=".5rem" align="center">
        <CardCol>
          <Input
            type="number"
            defaultValue={this.state.priceMin}
            name="priceMin"
            placeholder="Min"
            className={`filter-price-min ${this.props.className}`}
            onChange={this.onPriceMinChange}
          />
        </CardCol>
        <CardCol>
          <Input
            type="number"
            defaultValue={this.state.priceMax}
            name="priceMax"
            placeholder="Max"
            className={`filter-price-max ${this.props.className}`}
            onChange={this.onPriceMaxChange}
          />
        </CardCol>
      </CardRow>
    )
  }
}

export default FilterPrices
